const addUrlHostName = (path: string) =>
  path.startsWith('/') ? `${process.env.NEXT_PUBLIC_HOSTNAME ?? ''}${path}` : path;

export default addUrlHostName;
